<div class="mapContainer" [id]="mapContainerName">
</div>